import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {environment} from "src/environments/environment";
import {
  AppNews,
  AppNewsCommand,
  AppNewsPendingResponse,
} from "../interfaces/app-news.interface";

@Injectable({providedIn: "root"})
export class AppNewsService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiDomain;

  getAdmin() {
    return this.http.get<AppNews>(`${this.api}/api/admin/news`);
  }

  save(command: AppNewsCommand, file?: File) {
    if (!file)
      return this.http.put<AppNews>(`${this.api}/api/admin/news`, command);
    const data = new FormData();
    data.append("news", JSON.stringify(command));
    data.append("media", file);
    return this.http.put<AppNews>(`${this.api}/api/admin/news`, data);
  }

  pending() {
    return this.http.get<AppNewsPendingResponse>(`${this.api}/news`);
  }

  markSeen(revision: number) {
    return this.http.post<void>(`${this.api}/news/seen`, {revision});
  }
}
